import { getTranslation } from 'utils/getTranslation';
import * as yup from 'yup';

type MicrochipSettingsSchemaType = {
  price: number;
};

export type DonorSettingsSchemaType = {
  microchip: MicrochipSettingsSchemaType;
};

const t = getTranslation('settings.DonorSettings.ValidationErrors');

const microchipSettingsSchema = yup.object().shape({
  price: yup
    .number()
    .typeError(t('number'))
    .positive(t('positive'))
    .required(t('required')),
}) as yup.SchemaOf<MicrochipSettingsSchemaType>;

export const donorSettingsSchema = yup.object().shape({
  microchip: microchipSettingsSchema,
}) as yup.SchemaOf<DonorSettingsSchemaType>;
